/**
 * Construct 3 must load from a real static URL.
 * Amplify SPA rewrites /halloween/play.html → index.html on same origin.
 * Hosted builds load from the public S3 bucket (REACT_APP_S3BUCKET_URL).
 */
function getPublicGameBaseUrl() {
  const explicit = process.env.REACT_APP_HALLOWEEN_PLAY_URL;
  if (explicit && String(explicit).trim()) {
    return String(explicit).trim().replace(/\/play\.html$/i, '');
  }

  const publicBucket = process.env.REACT_APP_S3BUCKET_URL;
  const folder = process.env.REACT_APP_S3_GAME_FOLDER || 'halloween_react';
  if (publicBucket && String(publicBucket).trim()) {
    return `${String(publicBucket).trim().replace(/\/$/, '')}/${String(folder).replace(/^\//, '')}`;
  }

  const legacyPrivate = process.env.REACT_APP_S3_PATH;
  if (legacyPrivate && String(legacyPrivate).trim()) {
    return String(legacyPrivate).trim().replace(/\/$/, '');
  }

  return null;
}

export function getHalloweenPlayUrl() {
  const localPath = `${process.env.PUBLIC_URL || ''}/halloween/play.html`;

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return localPath;
    }
  } else if (process.env.NODE_ENV !== 'production') {
    return localPath;
  }

  const remoteBase = getPublicGameBaseUrl();
  if (remoteBase) {
    return `${remoteBase}/play.html`;
  }

  return localPath;
}

/** Origins allowed to post game-over score messages (CDN/S3 + Amplify). */
export function isAllowedHalloweenScoreOrigin(origin) {
  if (!origin || typeof window === 'undefined') return false;
  if (origin === window.location.origin) return true;

  const remoteBase = getPublicGameBaseUrl();
  if (remoteBase) {
    try {
      if (origin === new URL(remoteBase).origin) return true;
    } catch {
      /* ignore */
    }
  }

  const legacy = process.env.REACT_APP_S3_PATH;
  if (legacy) {
    try {
      if (origin === new URL(legacy).origin) return true;
    } catch {
      /* ignore */
    }
  }

  return false;
}
